import { __extends } from "tslib";
import * as React from 'react';
import { ProductLineItemDataHook } from '../../ProductLineItem';
import { Counter, CounterSize, Popover } from 'wix-ui-tpa';
import { classes, st } from './Quantity.st.css';
var Quantity = /** @class */ (function (_super) {
    __extends(Quantity, _super);
    function Quantity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Quantity.prototype.render = function () {
        var _a = this.props, quantity = _a.quantity, hasQuantityError = _a.hasQuantityError, inventoryQuantity = _a.inventoryQuantity, handleChange = _a.handleChange, incrementAriaLabel = _a.incrementAriaLabel, decrementAriaLabel = _a.decrementAriaLabel, inputAriaLabel = _a.inputAriaLabel, quantityAriaLabel = _a.quantityAriaLabel, tooltipContent = _a.tooltipContent, className = _a.className;
        return (React.createElement(Popover, { "data-hook": ProductLineItemDataHook.QuantityErrorTooltip, className: st(classes.root, className), width: 165, shown: hasQuantityError, placement: "top" },
            React.createElement(Popover.Element, null,
                React.createElement(Counter, { disabled: inventoryQuantity === 0, className: classes.quantity, size: CounterSize.xSmall, error: hasQuantityError, value: quantity, step: 1, "data-hook": ProductLineItemDataHook.Quantity, onChange: handleChange, incrementAriaLabel: incrementAriaLabel, decrementAriaLabel: decrementAriaLabel, inputAriaLabel: inputAriaLabel, "aria-label": quantityAriaLabel, min: 1, max: inventoryQuantity || 99999 })),
            React.createElement(Popover.Content, null,
                React.createElement("span", { role: "alert" }, tooltipContent))));
    };
    Quantity.displayName = 'ProductLineItem.Quantity';
    return Quantity;
}(React.PureComponent));
export { Quantity };
//# sourceMappingURL=Quantity.js.map